import { Box, SxProps, Theme, Typography } from "@mui/material";
import { intl } from "LocaleWrapper";
import EntityHistoryValue from "components/entityHistory/components/EntityHistoryValue";
import {
	GeneralEntitySnapshotFragment,
} from "__generated__/components/entityHistory/graphql/entityHistory.fragments.generated";
import { changeColor } from "components/entityHistory/utils/entityHistory.utils";
import GroupHeader from "components/entityHistory/components/changes/GroupHeader";
import { Fragment } from "react";

const RevisionSnapshots = ({ snapshots, revisionId }: {
	snapshots: GeneralEntitySnapshotFragment[];
	revisionId: number;
}) => {

	if (snapshots.length === 0) {
		return (
			<Typography variant="body2" color="text.secondary">
				{intl.formatMessage({ id: "HISTORY_SNAPSHOT_EMPTY" })}
			</Typography>
		);
	}

	return (
		<Box
			sx={{
				display: "grid",
				gridTemplateColumns: "min-content auto 1fr",
				alignItems: "stretch",
			}}
		>
			{([
				{ id: null },
				{ id: "ENTITY" },
				{ id: "VALUE" },
			]).map(header => (
				<Box
					key={header.id}
					sx={{
						pr: 1.5,
						display: "flex",
						alignItems: "center",
						justifyContent: "flex-start",
						borderBottom: "1px solid",
						borderColor: "divider",
					}}
				>
					{header.id && (
						<Typography variant="caption" color="text.secondary" fontWeight={600}>
							{intl.formatMessage({ id: header.id })}
						</Typography>
					)}
				</Box>
			))}
			{snapshots.map((snapshot, index) => {
				const changeType = snapshot.revision.id === revisionId ? snapshot.changeType : null;
				const color = changeType ? changeColor[changeType] : "#888";

				const cell: Readonly<SxProps<Theme>> = {
					backgroundColor: index % 2 === 1 ? "action.hover" : "transparent",
					py: 0.5,
					pr: 1.5,
					display: "flex",
					alignItems: "center",
					flexWrap: "wrap",
					gap: 0.5,
				};

				return (
					<Fragment key={snapshot.id}>
						<GroupHeader
							sx={cell}
							entity={{ changeType, entityKey: snapshot.entityKey, path: snapshot.path }}
						/>
						<Box sx={cell}>
							<EntityHistoryValue value={snapshot.snapshotValue} />
						</Box>
					</Fragment>
				);
			})}
		</Box>
	);
};

export default RevisionSnapshots;
